import { render } from "./taxStatistics.vue?vue&type=template&id=6c786d15&scoped=true"
import script from "./taxStatistics.vue?vue&type=script&lang=js"
export * from "./taxStatistics.vue?vue&type=script&lang=js"

import "./taxStatistics.vue?vue&type=style&index=0&id=6c786d15&lang=less&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c786d15"]])

export default __exports__